import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconBurger = ({
  title = "Burger",
  color = "darkerRed",
  viewBoxWidth = 24,
  viewBoxHeight = 20,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <path
      d="M14 16a2 2 0 110 4H2a2 2 0 110-4h12zm8-8a2 2 0 110 4H2a2 2 0 110-4h20zm0-8a2 2 0 110 4H2a2 2 0 110-4h20z"
      fill={uiColorToBaseColor(color)}
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconBurger
